'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const connectToStores = require('fluxible-addons-react/connectToStores');
const provideContext = require('fluxible-addons-react/provideContext');

const User = require('../../global/models/User');
const recommendationsActions = require('../../global/actions/recommendationsActions.es');
const trendingActions = require('../../global/actions/trendingActions');
const RecommendationsStore = require('../../global/stores/RecommendationsStore.es');
const TrendingStore = require('../../global/stores/TrendingStore');
const {Personalization} = require('../components/carousels');
const {ACTIONS: TRENDING_ACTIONS} = require('../../global/constants/trendingConstants');
const {ACTIONS: RECOMMENDATIONS_ACTIONS} = require('../../global/constants/recommendationsConstants');

const ITEMS_PER_PAGE = 5;
const ITEMS_TO_FETCH = 10;

function getCarouselData(keys, fluxStore, context) {
    const store = context.getStore(fluxStore);

    return {
        models: store.getCollectionsFiltered(keys, ITEMS_PER_PAGE)
    };
}

function renderCarousel({container, context, connector, stores, tracking}) {
    const component = provideContext(connectToStores(Personalization, stores, connector));

    ReactDOM.render(
        React.createElement(component, {
            context: context.getComponentContext(),
            tracking
        }), container);
}

const personalizationHelpers = {
    CATEGORY_KEY: 'homepageSliderCategory',
    ATTRIBUTE_KEY: 'homepageSliderAttribute',
    TRENDING_KEY: 'homepageSliderTrending',

    render(options) {
        const {
            context,
            container,
            dataKeys = [this.CATEGORY_KEY, this.ATTRIBUTE_KEY], // order matters
            categoryLevels = 1
        } = options;

        if (!User.loggedIn()) {
            return Promise.resolve(true);
        }

        return Promise.all([
            context.executeAction(recommendationsActions.fetchByCategory, {
                collectionKey: this.CATEGORY_KEY,
                pageSize: 2,
                itemsPageSize: ITEMS_TO_FETCH,
                fields: RECOMMENDATIONS_ACTIONS.FIELDS.IMAGES
            }),
            context.executeAction(recommendationsActions.fetchByAttribute, {
                collectionKey: this.ATTRIBUTE_KEY,
                pageSize: 2,
                itemsPageSize: ITEMS_TO_FETCH,
                fields: RECOMMENDATIONS_ACTIONS.FIELDS.IMAGES,
                categoryLevels
            })
        ])
        .then(() => {
            const data = getCarouselData(dataKeys, RecommendationsStore, context);

            if (data.models.length) {
                return {
                    connector: getCarouselData.bind(this, dataKeys, RecommendationsStore),
                    stores: [RecommendationsStore],
                    container,
                    context
                };
            } else {
                return context.executeAction(trendingActions.fetchByCategory, {
                    collectionKey: this.TRENDING_KEY,
                    pageSize: 4,
                    itemsPageSize: ITEMS_PER_PAGE,
                    fields: TRENDING_ACTIONS.FIELDS.IMAGES
                })
                .then(() => {
                    return {
                        connector: getCarouselData.bind(this, [this.TRENDING_KEY], TrendingStore),
                        stores: [TrendingStore],
                        container,
                        context
                    };
                });
            }
        })
        .then(payload => renderCarousel(payload));
    }
};

module.exports = personalizationHelpers;



// WEBPACK FOOTER //
// ./assets/js/home/helpers/personalizationHelpers.es.js